import type { BlogPost } from '../db/catalog';

export const DEFAULT_POSTS: BlogPost[] = [
  {
    id: '83512987-c621-44b5-adfe-6fba997ecbcf',
    title: 'Hola, soy Elizabeth',
    slug: 'hola-soy-elizabeth',
    excerpt: 'Conocé la historia y el corazón detrás de Satibax Boutique: un viaje de aprendizajes, resiliencia y amor por la cosmética natural.',
    content: `Y creo que si esta es la primera entrada del blog, corresponde empezar por ahí.
Soy Elizabeth, la persona detrás de Satibax Boutique.

Hace tiempo que tenía ganas de abrir este espacio porque me gusta escribir. Me gusta poner en palabras las cosas que pienso, las cosas que vivo y las preguntas que me hago.

Y si soy sincera, no sabía muy bien cuál tenía que ser el primer tema.

Pensé en hablar de la tienda, de los productos, de cómo empezó todo.

Pero al final me di cuenta de que antes de hablar de Satibax, tenía que hablar un poco de mí.

Porque Satibax no apareció de la nada.

Nació de una parte de mi historia. 

De momentos lindos y de momentos difíciles.

De decisiones acertadas y de otras que no tanto.

De búsquedas, de cambios y de esas etapas donde una siente que está perdida y no entiende muy bien para dónde va.

Durante mucho tiempo me enojé con algunas cosas que me pasaron.

Pensaba: "¿Por qué esto?", "¿Por qué ahora?", "¿Por qué de esta manera?".

Y con los años empecé a mirar esas mismas situaciones desde otro lugar.

No porque hayan dejado de doler o porque de repente se hayan vuelto maravillosas.

Sino porque entendí que muchas veces las cosas simplemente son.

No necesariamente buenas.
No necesariamente malas.

Son circunstancias.

Y después somos nosotros quienes decidimos qué hacemos con eso.

Si nos quedamos atrapados en el dolor o si intentamos encontrar algo que aprender en el camino.

No siempre se puede enseguida.

Hay procesos que llevan tiempo.

Hay tormentas que hay que atravesar antes de entender qué vinieron a enseñarnos.

Y creo que gran parte de mi vida, y también de Satibax, tiene que ver con eso.

Con aprender a atravesar.

Con seguir adelante aun cuando no tenemos todas las respuestas.

Con descubrir que a veces de los momentos más incómodos nacen las transformaciones más importantes.

Por eso quería que este primer post fuera simple.

Sin fórmulas.
Sin frases perfectas.

Solo una presentación.

Un "hola, esta soy yo".

Y una invitación a compartir este espacio donde seguramente vamos a hablar de naturaleza, bienestar, emprendimiento, emociones, aprendizajes y de todo aquello que nos ayude a vivir un poco más conscientes.

Gracias por estar acá.

Nos seguimos leyendo.

Elizabeth 🌿`,
    cover_image: null,
    published: true,
    created_at: '2026-05-28T18:05:06.93732-05:00',
  },
  {
    id: '94623812-d732-44b6-be0e-7fca886ecbde',
    title: 'Ritual Facial Nocturno: Cómo integrar el Retinol Vegetal en tu descanso',
    slug: 'ritual-facial-nocturno-retinol-vegetal',
    excerpt: 'Descubrí cómo potenciar la regeneración celular durante la noche con activos botánicos respetuosos y ácido hialurónico.',
    content: `La noche es el momento sagrado donde nuestra piel activa sus procesos naturales de regeneración y reparación celular.

Durante el descanso, la barrera cutánea se relaja y se vuelve infinitamente más receptiva a los activos transformadores de la naturaleza.

### El Secreto del Retinol y el Ácido Hialurónico
Al combinar retinol botánico de alta tolerancia con ácido hialurónico puro, hidratamos en profundidad mientras estimulamos la síntesis de colágeno sin agredir la piel sensible.

A diferencia de los tratamientos invasivos, un serum natural respeta el microbioma cutáneo y revitaliza la luminosidad desde la primera aplicación.

### Paso a paso para tu rutina nocturna consciente:
1. **Limpieza consciente:** Usá agua tibia y un jabón natural botánico que limpie sin resecar.
2. **Bruma o tónico vegetal:** Calma, tonifica y equilibra el pH de la piel.
3. **Serum Retinol Night Repair:** Aplicá 3 o 4 gotas en la palma de tu mano y distribuilas con suaves presiones sobre rostro, cuello y escote.
4. **Hidratación selladora:** Una crema nutritiva o emulsión botánica para sellar los activos.

*Consejo botánico: Usá siempre protector solar a la mañana siguiente para cuidar los nuevos tejidos regenerados.*`,
    cover_image: null,
    published: true,
    created_at: '2026-06-15T10:00:00.000Z',
  },
  {
    id: 'a5734923-e843-45c7-cf1f-8adb997fde01',
    title: 'Piedra de Alumbre: La alternativa natural y milenaria para el cuidado corporal',
    slug: 'piedra-de-alumbre-desodorante-natural',
    excerpt: 'Todo lo que necesitás saber sobre el alumbre de potasio: cómo funciona, sus beneficios antibacterianos y por qué no obstruye los poros.',
    content: `En la búsqueda de alternativas saludables a los antitranspirantes convencionales con sales de aluminio sintéticas, la piedra de alumbre de potasio destaca por su pureza, nobleza y eficacia milenaria.

El alumbre de potasio es un mineral 100% natural extraído de la naturaleza, sin agregados químicos ni perfumes artificiales.

### ¿Por qué elegirla?
- **No obstruye los poros:** A diferencia de los antitranspirantes químicos, no bloquea el proceso biológico y saludable de la sudoración, sino que neutraliza las bacterias responsables del mal olor.
- **Acción antiséptica y astringente:** Deja una fina capa mineral invisible que purifica la piel de manera suave.
- **Hipoalergénica y segura:** Libre de alcohol, fragancias sintéticas y parabenos. Es ideal para pieles muy sensibles y post-depilación.
- **Durabilidad asombrosa:** Una sola piedra puede acompañarte durante más de un año de uso diario.

### Modo de uso simple:
Humedecé la punta de la piedra con un poco de agua limpia y aplicala suavemente sobre la piel limpia de tus axilas o pies. Seca rápidamente y no mancha tus prendas favoritas.`,
    cover_image: null,
    published: true,
    created_at: '2026-07-02T14:30:00.000Z',
  },
];
